import { presentation } from '../vue'

export default {
	namespace: 'project',
	beforeEnter(barba) {

		const setContentOffset = () => {
			let heroImage = barba.next.container.querySelector('.heroImage'),
				headerHeight = document.getElementsByTagName('header')[0].offsetHeight,
				scrollWrapper = barba.next.container.querySelector('.scroll-wrapper')
			
			scrollWrapper.style.marginTop = `${(heroImage.offsetHeight - headerHeight)}px`
		}
		// run setContentOffset() on load
		setContentOffset()
		// run setContentOffset() on resize
		window.addEventListener('resize', setContentOffset)


		// PRESENTATION VIEWER
		presentation()

	},
	beforeLeave() {

	},
	afterLeave() {

	}
}
